'use strict';

var React = require('react');

var SvgPhoneOutMajor = function SvgPhoneOutMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.105 2.1h3.995c.553 0 1 .446 1 .999v3.995a.997.997 0 0 1-1.705.708.998.998 0 0 1-.293-.707v-1.584l-3.336 3.335a.999.999 0 0 1-1.413-1.411l3.337-3.335h-1.584a.999.999 0 0 1-.705-1.707.993.993 0 0 1 .705-.293zm-5.763 2.206.534 2.67a1.495 1.495 0 0 1-.802 1.634l-.975.488c0 2 3 5 5 5l.488-.975a1.5 1.5 0 0 1 1.636-.8l2.67.534a1.5 1.5 0 0 1 1.206 1.471v3.235c0 .859-.725 1.572-1.584 1.535-8.915-.388-13.954-4.251-14.414-14.412-.039-.859.677-1.586 1.537-1.586h3.233a1.5 1.5 0 0 1 1.471 1.206z"
  }));
};

exports.SvgPhoneOutMajor = SvgPhoneOutMajor;
